export const contactWebsite = "https://www.waku-robotics.com";
export const contactHelpAddress = "support+care@waku-robotics.com";
export const contactSalesAddress = "sales+care@waku-robotics.com";
export const calendlySalesUrl = "https://calendly.com/meet-leo-from-waku/waku-care-offer?hide_gdpr_banner=1";
